import { render, staticRenderFns } from "./GatewayBindingsForm.vue?vue&type=template&id=c819bbe0&"
import script from "./GatewayBindingsForm.vue?vue&type=script&lang=js&"
export * from "./GatewayBindingsForm.vue?vue&type=script&lang=js&"
import style0 from "./GatewayBindingsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports